<template>
    <el-table
      :data="adjustments"
      stripe
      v-loading="loadingAdjustment">
      <div slot="empty">
        <span>{{$t('adjustments.noAdjustment')}}</span>
      </div>
      <el-table-column type="expand">
      <template slot-scope="props">
        <div v-for="(d, index) in props.row.inventory_adjustment_details" :key="d.id">
          <span class="fs-14 secondary-text">{{$t('adjustments.batch')}} {{d.item.reference}}</span><br>
          <span class="fs-14 secondary-text">{{$t('adjustments.adjustment')}} {{d.adjusted_qty}}</span><br>
          <span class="fs-14 secondary-text" v-if="props.row.adjustment_reason">{{$t('adjustments.reason')}} {{props.row.adjustment_reason.languages[0].adjustment_reason_language.name}}</span><br>
          <span class="fs-14 secondary-text">{{$t('adjustments.description')}} {{props.row.description}}</span>
          <el-divider v-if="(index+1)<props.row.inventory_adjustment_details.length"/>
        </div>
      </template>
    </el-table-column>
      <el-table-column prop="mode" sortable :label="$t('adjustments.mode')" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.mode==0">{{ $t('adjustments.quantity') }}</span>
          <span v-else>Valeur</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="effective_date"
        :label="$t('adjustments.quantity')"
        sortable>
        <template slot-scope="scope">
           {{_moment(scope.row.effective_date)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('adjustments.reasonLbl')">
        <template slot-scope="scope" >
          <span style="word-break:break-word;" v-if="scope.row.adjustment_reason">{{scope.row.adjustment_reason.languages[0].adjustment_reason_language.name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        :label="$t('adjustments.adjustmentLbl')"
        width="100">
        <template slot-scope="scope">
            {{sumAdjustment(scope.row.inventory_adjustment_details)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('adjustments.referenceLbl')"
        prop="reference"
        sortable>
      </el-table-column>
      <el-table-column width="75">
        <template slot-scope="scope">
          <el-button :disabled="false"
            size="mini"
            circle
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"><i class="mdi mdi-delete" style="font-size:15px;"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import adjustmentAPI from '@/services/API/adjustment';

export default {
  name: 'adjustment-table',
	props: {
    puid: {
      type: String,
      default: null
    },
    productId : {
      type : Number,
      default : null
    },
    itemId : {
      type : Number,
      default : null
    },
    inventoryId : {
      type : Number,
      default : null
    }
	},
  data() {
    return {};
  },components: {},
  watch : {
    puid : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchAdjustments({ puid: newVal, paging:'no'});
      }
    },
    productId : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchAdjustments({productId:this.productId, itemId:this.itemId,inventoryId:this.inventoryId, paging:'no'});
      }
    },
    itemId : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchAdjustments({productId:this.productId, itemId:this.itemId,inventoryId:this.inventoryId, paging:'no'});
      }
    },
    inventoryId : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchAdjustments({productId:this.productId, itemId:this.itemId,inventoryId:this.inventoryId, paging:'no'});
      }
    }
  },
	methods: {
    getReason(adj) {
      const reason = _.get(adj, 'adjustment_reason.languages');
      if (reason != null) {
        return reason[0].adjustment_reason_language.name
      }
      return null;
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    handleDelete(index, adjustment){
      this.$confirm("Ceci supprimera définitivement l'ajustement du système. Continuer?", 'Attention', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          this.deleteAdjustmentItem(index)
            .then(()=>{
              this.$emit("deleted");
              this.$message({
                type: 'success',
                message: "Ajustement d'inventaire supprimé"
              });
            }).catch(err=>{
              this.$message({
                type: 'error',
                message: "Une erreur système s'est produit. Veuillez réessayer plus tard"
              });
            })

        }).catch(() => {});

    },
    sumAdjustment(details){
      let sum = 0;
      _.forEach(details, d=>{
        sum+=d.adjusted_qty;
      })
      return sum;
    },
    ...mapActions('inventoryAdjustment', ['fetchAdjustments','deleteAdjustmentItem']),
	},
	computed: {

    ...mapState('inventoryAdjustment', ['adjustments', 'loadingAdjustment'])

	},
  mounted(){
    this.fetchAdjustments({puid: this.puid, productId:this.productId, itemId:this.itemId,inventoryId:this.inventoryId, paging:'no'});
  }
}
</script>
<style lang="scss" scoped>




</style>
